import { render, staticRenderFns } from "./IP_ByOriginalAuditor.vue?vue&type=template&id=4294edc6&scoped=true&"
import script from "./IP_ByOriginalAuditor.vue?vue&type=script&lang=js&"
export * from "./IP_ByOriginalAuditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4294edc6",
  null
  
)

export default component.exports